import { PermissionGuard } from "@/components/PermissionGuard";
import { PatientFinancialTab } from "@/components/patients/PatientFinancialTab";

interface MobilePetFinancialTabProps {
  petId: string;
}

export function MobilePetFinancialTab({ petId }: MobilePetFinancialTabProps) {
  return (
    <PermissionGuard resource="patient_financial" action="view" showAlert={false}>
      <PatientFinancialTab petId={petId} />
    </PermissionGuard>
  );
}
